import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactSelect, { createFilter } from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';
import { fetchTags } from 'actions';

import { REACT_SELECT_STYLES } from 'helpers/styles';

const tagDisplayValue = (tag) => tag.display_value || tag.value || '';

const tagComparator = (tagA, tagB) => {
  const lcaseTagA = tagDisplayValue(tagA).toLowerCase();
  const lcaseTagB = tagDisplayValue(tagB).toLowerCase();
  return lcaseTagA.localeCompare(lcaseTagB);
};

class TagSelect extends Component {
  constructor() {
    super();

    this.state = {
      isLoading: true,
      options: [],
    };
  }

  componentDidMount() {
    this.loadTags();
  }

  loadTags = async () => {
    const { dispatch, tagType } = this.props;

    const tags = await dispatch(fetchTags(tagType));
    this.setState({
      options: tags.sort(tagComparator),
      isLoading: false,
    });
  };

  tagsFilter = createFilter({
    ignoreAccents: true,
    ignoreCase: true,
    matchFrom: 'any',
  });

  render() {
    let SelectComponent = ReactSelect;
    let creatableProps = {};

    if (this.props.allowCreate) {
      SelectComponent = ReactSelectCreatable;
      creatableProps = {
        formatCreateLabel: (value) => `Create tag "${value}"`,
      };
    }

    return (
      <SelectComponent
        name="tags"
        isLoading={this.state.isLoading}
        isMulti
        isClearable
        autoFocus={this.props.autoFocus}
        tabSelectsValue={false}
        placeholder={this.props.placeholder}
        noOptionsMessage={() => this.props.noOptionsMessage}
        filterOptions={this.tagsFilter}
        defaultValue={this.props.initialValue}
        styles={REACT_SELECT_STYLES}
        options={this.state.options}
        getOptionLabel={({ display_value, label, __isNew__ }) => {
          return __isNew__ ? label : display_value;
        }}
        getOptionValue={({ display_value }) => display_value}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        onBlur={this.props.onBlur}
        {...creatableProps}
      />
    );
  }
}

TagSelect.propTypes = {
  allowCreate: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  autoFocus: PropTypes.bool,
  tagType: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  initialValue: PropTypes.any,
};

TagSelect.defaultProps = {
  allowCreate: false,
  placeholder: '',
  noOptionsMessage: null,
  autoFocus: false,
  tagType: 'media',
  disabled: false,
};

export default connect()(TagSelect);
